import React from 'react';
import { FulfillmentOptions } from './FulfillmentOptions';
import './ManagerModal.scss';
import { MenuSelector } from './MenuSelector';
import { NameEditor } from './NameEditor';
import { DeliveryTextEditor } from './DeliveryTextEditor';
import { DeliverySetupSelector } from './DeliverySetupSelector';
import { CenterModel } from '../types';
import { FufillmentCenterModalStep, ModelChangeHandler, ManagerModalProps } from './types';

export const steps: FufillmentCenterModalStep[] = [
  {
    key: 'name',
    name: 'Fulfillment Station Name',
    description:
      'Give your fulfillment station a name. This will be viewed publicly when customers choose which ' +
      'location to order from.',
    component: (data: CenterModel, onChange: ModelChangeHandler) => <NameEditor data={data} onChange={onChange} />,
  },
  {
    key: 'menuId',
    name: 'Fulfillment Station Menu',
    description:
      'Please choose a menu to associate with this fulfillment station. A fulfillment station will not ' +
      'show up unless a menu is associated with it.',
    component: (data: CenterModel, onChange: ModelChangeHandler, props: ManagerModalProps) => (
      <MenuSelector data={data} onChange={onChange} menus={props.menus} />
    ),
  },
  {
    key: 'options',
    name: 'Fulfillment Station Options',
    description:
      'Choose whether this fulfillment station will allow pick-up, delivery, or both. ' +
      'These will be the default options for this station.',
    component: (data: CenterModel, onChange: ModelChangeHandler) => (
      <FulfillmentOptions data={data} onChange={onChange} />
    ),
  },
  // {
  //   key: 'pickupText',
  //   name: 'Pick-up Confirmation',
  //   description: 'We include a standard pick-up message that works for most venues. '
  //              + 'If you need to customize it, do so below.',
  //   component: (data, onChange) => <TextEditor onChange={onChange} value={data.pickupText} />,
  // },
  {
    key: 'deliveryText',
    name: 'Delivery Setup',
    showIf(data: CenterModel) {
      return data.options.delivery;
    },
    description:
      'Please select the delivery setup to use for this fuflillment station. This controls the delivery fields customers see. Please react out to Noble support to get new setups added.',
    component(data: CenterModel, onChange: ModelChangeHandler, props) {
      return (
        <DeliverySetupSelector data={data} onChange={onChange} deliveryConfigurations={props.deliveryConfigurations} />
      );
    },
  },
  {
    key: 'deliveryText',
    name: 'Delivery Confirmation',
    showIf(data: CenterModel) {
      return data.options.delivery;
    },
    description:
      'We include a standard delivery message that works for most venues. ' +
      'If you need to customize it, do so below.',
    component(data: CenterModel, onChange: ModelChangeHandler) {
      return <DeliveryTextEditor onChange={onChange} data={data} />;
    },
  },
];
